<template>
  <v-layout justify-space-around row wrap scrollDesign style="max-height: 60vh;">
    <v-flex xs11>
      <h1>{{ notice.title }}</h1>
    </v-flex>
    <v-flex xs12 sm6>
      <v-layout row wrap>
        <v-flex xs12>
          <v-layout row wrap justify-center>
            <v-flex xs12 v-if="notice.imgs != null && notice.imgs.length > 0">
              <v-container grid-list-md>
                <v-layout wrap row>
                  <v-slide-y-transition v-for="(image, key) in notice.imgs" :key="key">
                    <v-flex :key="key" xs12 md4>
                      <v-card class="d-flex align-center" dark>
                        <v-img :src="image"></v-img>
                      </v-card>
                    </v-flex>
                  </v-slide-y-transition>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex v-else-if="notice.type == 'A'" xs6 key="A">
              <v-img :src="require('@/assets/notices/SKLB-Aviso 3.png')"></v-img>
              <br />
            </v-flex>
            <v-flex v-else-if="notice.type == 'E'" xs6 key="E">
              <v-img :src="require('@/assets/notices/SKLB-Evento.png')"></v-img>
              <br />
            </v-flex>
            <v-flex v-else-if="notice.type == 'R'" xs6 key="R">
              <v-img :src="require('@/assets/notices/SKLB-informe.png')"></v-img>
              <br />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap justify-space-around scrollDesign style="max-height: 320px;">
            <v-flex xs12 sm6 v-if="notice.institutional">
              <v-alert
                style="border-radius:33px;"
                :value="true"
                type="info"
                color="gradiente"
              >Toda la institución será notificada</v-alert>
            </v-flex>
            <v-flex xs12 sm4 v-if="notice.levels.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Niveles</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in notice.levels"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.typeLevel"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>
            <v-flex xs12 sm4 v-if="notice.groups.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Grupos</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in notice.groups"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.grade + ' ' + element.group"></v-list-tile-title>
                      <v-list-tile-sub-title v-text="element.level.typeLevel"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>
            <v-flex xs12 sm4 v-if="notice.students.length > 0">
              <v-list subheader two-line>
                <v-subheader key="subheader">Alumnos</v-subheader>
                <v-slide-y-transition class="two-line subheader" group>
                  <v-list-tile
                    avatar
                    class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                    style="border-radius: 5px;"
                    v-for="element in notice.students"
                    :key="element.id"
                  >
                    <v-list-tile-avatar>
                      <v-img :src="require('@/assets/panel/home/SKLB-Alumnos.png')"></v-img>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="element.firstName + ' ' + element.lastName"></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-text="element.level.typeLevel + ' ' + element.gg.grade + ' ' + element.gg.group"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-slide-y-transition>
              </v-list>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm5 class="innerContainer">
      <v-list dense>
        <v-list-tile>
          <v-list-tile-content><strong>Tipo:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">
            <v-chip disabled>
              <v-avatar>
                <img v-if="notice.type == 'A'" :src="require('@/assets/notices/aviso.png')" />
                <img v-else-if="notice.type == 'E'" :src="require('@/assets/notices/evento.png')" />
                <img v-else-if="notice.type == 'R'" :src="require('@/assets/notices/informe.png')" />
                <img v-else-if="notice.type == 'P'" :src="require('@/assets/notices/permiso.png')" />
              </v-avatar>
              {{ notice.type | noticeTypeFilter }}
            </v-chip>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="notice.students.length == 0 && notice.groups.length == 0 && notice.levels.length == 0"
        >
          <v-list-tile-content><strong>Escala:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">
            <v-chip>
              <v-avatar>
                <v-icon color="primary">account_balance</v-icon>
              </v-avatar>Institucional
            </v-chip>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="notice.type == 'E'">
          <v-list-tile-content><strong>Confirmación del tutor:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">
            <v-checkbox color="primary" v-model="v.confirmParent.$model" hide-details></v-checkbox>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="notice.type == 'E'">
          <v-list-tile-content><strong>Asistencia del tutor:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">
            <v-checkbox color="primary" v-model="v.assistanceRequired.$model" hide-details></v-checkbox>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="notice.type == 'E'">
          <v-list-tile-content><strong>Fecha inicio:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">{{ notice.startDate | dateFormat2}}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="notice.type == 'E' && notice.endDate != null && notice.endDate != ''">
          <v-list-tile-content><strong>Fecha término:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">{{ notice.endDate | dateFormat2}}</v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list three-line dense class="py-0">
        <v-list-tile v-if="notice.type == 'E'">
          <v-list-tile-content>
            <v-list-tile-title><strong>Lugar:</strong></v-list-tile-title>
            <v-list-tile-sub-title class="align-end">{{ notice.place }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list dense>
        <v-list-tile v-if="notice.files.length > 0">
          <v-list-tile-content><strong>Archivos adjuntos:</strong></v-list-tile-content>
          <v-list-tile-content class="align-end">{{ notice.files.length }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-flex xs12 px-3>
        <strong>Descripción:</strong>
        <br />
        <v-flex xs12 scrollDesign style="max-height: 200px;">
          <p>{{ notice.description }}</p>
        </v-flex>
      </v-flex>
    </v-flex>

    <v-flex xs12 sm3></v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
export default {
  props: ["notice", "v"],
  filters: {
    noticeTypeFilter: function(type) {
      switch (type) {
        case "A":
          return "Aviso";
        case "E":
          return "Evento";
        case "P":
          return "Permiso";
        case "R":
          return "Reporte";
      }
    },
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  }
};
</script>

<style>
.innerContainer {
  border-radius: 13px;
  background-color: white;
  border-color: #e6e6e6 !important;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
</style>
